<script setup>
import { useRoute } from 'vue-router'
import { prepareRegFlowHashForPulseInit } from '~/utils/location-av-chart-deeplink'
// TODO Add the basic SEO information for each page: Title, Meta Description

// ZigZag required scripts and styles
const config = useRuntimeConfig()

const { version } = useZigZag()
const { data, refresh: _refresh, error: _error } = await version(config.public.zigzagUrl)

const time = data.value ? data.value.t : 0;
const sha = data.value ? data.value.sha : 'versionnotfound';

onMounted(() => {
  useHead({      
    link: [    
      {
        rel: 'stylesheet',
        href: `${config.public.zigzagUrl}/styles/pulseapp.css?sha=${sha}&t=${time}`
      }
    ]
  }); 

  if (typeof angular === 'undefined' || angular === null) {
    useHead({
      script: [        
        {
          src: `${config.public.zigzagUrl}/${config.public.zigzag3rdParty}?sha=${sha}&t=${time}`,
          body: true,          
          onload: () => {
            prepareRegFlowHashForPulseInit({ pathname: route.path, hash: route.hash })
            const script = document.createElement("script");
            script.src = `${config.public.zigzagUrl}/${config.public.zigzagPulseApp}?sha=${sha}&t=${time}`;
            script.id = 'pulse-app-script';
            document.body.appendChild(script);             
          }
          
        }
      ]
    });
  }
  else {
    prepareRegFlowHashForPulseInit({ pathname: route.path, hash: route.hash })
    // Forcing a page reload to unmount a previous angularjs app 
    angular.reloadWithDebugInfo();
  } 
})

const route = useRoute()
useUtmAttributionCapture()
const mainClasses = computed(() => {
  return {
    'adjust-top': route.params.showPromoBanner === true
  }
})

/** Skip global placement when env is missing or invalid (avoids NaN / 0 breaking EmbeddedPlacement). */
const iterableGlobalPlacementId = computed(() => {
  const raw = config.public.iterableGlobalPlacementId
  const n = typeof raw === 'number' ? raw : Number(raw)
  return Number.isFinite(n) && n > 0 ? n : null
})
</script>
<template>
  <!-- Global Iterable placement at top of every page (client-only so failures never affect SSR) -->
  <ClientOnly>
    <IterableEmbeddedPlacement
      v-if="iterableGlobalPlacementId != null"
      :placement-id="iterableGlobalPlacementId"
      message-type="banner"
      banner-image-desktop-placement="right"
    />
    <template #fallback />
  </ClientOnly>
  <PromotionsBanner v-if="route.params.showPromoBanner" />    
  <LayoutNavBar :navColor="'dark'" :hero="false" :key="'navbar-overrided'" :promoBanner="route.params.showPromoBanner"/>
  <main class="no-hero" :class="mainClasses">
    <slot />
  </main>
  <LayoutFooterNavigation />
  <LayoutCookieWarning v-if="route.params.cookieBanner"/>
</template>